import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TProductLinesData, TProductLinesFields, TProductLinesListingProps } from '../types/productLinesListing.types';
import { StringField } from '../../../types/types';

export class ProductLinesListingModel {
  private readonly fields: null | TProductLinesFields;
  private readonly rendering?: ComponentRendering;

  constructor(props: TProductLinesListingProps) {
    this.fields = props?.fields || null;
    this.rendering = props?.rendering;
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get title(): StringField | undefined {
    return this.fields?.itemData?.fields?.lineListingTitle;
  }

  get productListData(): TProductLinesData | undefined {
    return this.fields?.apiData;
  }

  get url(): string | undefined {
    return this.fields?.itemData?.contextItemUrl;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
